import { Issue } from './issuesTypes';
import { IssueStatus } from '@server/issues';
import { colors, IconButton, Tooltip } from '@sweep-io/sweep-design';
import { Delete, Check } from '@sweep-io/sweep-design/dist/icons';
import { Stack, Box } from '@mui/material';
import { useState } from 'react';
import { OnUpdateIssueStatus } from '../aiAgentCenter/aiAgentsConsts';
import { usePermissions } from '../../permissions/usePermissions';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';

const IssueActions = ({
  issue,
  onUpdateStatus,
}: {
  issue: Issue;
  onUpdateStatus: OnUpdateIssueStatus;
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { evaluatePermissions } = usePermissions();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const [isAllowedToUpdateIssueStatus] = evaluatePermissions([
    { permission: 'edit:ai-agent:issues', crmOrgId: crmOrgId ?? '' },
  ]);

  const activeSx = {
    button: {
      backgroundColor: colors.blue[100],
      borderColor: colors.blue[500],
      'svg path': {
        stroke: colors.blue[500],
      },
      '&:hover': {
        backgroundColor: colors.blue[300],
        borderColor: colors.blue[500],
      },
    },
  };

  const getPayloadForStatus = (status: IssueStatus) => ({
    resourceName: issue.resourceName,
    issueId: issue.id,
    status,
  });

  const toggleResolve = async () => {
    setIsSubmitting(true);
    switch (issue.status) {
      case 'resolved':
        await onUpdateStatus(getPayloadForStatus('open'));
        break;
      case 'open':
        await onUpdateStatus(getPayloadForStatus('resolved'));
        break;
    }
    setIsSubmitting(false);
  };
  const toggleDismiss = async () => {
    setIsSubmitting(true);
    switch (issue.status) {
      case 'dismissed':
        await onUpdateStatus(getPayloadForStatus('open'));
        break;
      case 'open':
        await onUpdateStatus(getPayloadForStatus('dismissed'));
        break;
    }
    setIsSubmitting(false);
  };

  if (!isAllowedToUpdateIssueStatus) return null;

  return (
    <Stack direction="row" gap={1}>
      <Tooltip
        title={
          issue.status === 'dismissed'
            ? ''
            : issue.status === 'resolved'
              ? 'Undo resolve'
              : 'Resolve'
        }
      >
        <Box sx={issue.status === 'resolved' ? activeSx : {}}>
          <IconButton
            variant="system"
            onClick={(e) => {
              e.stopPropagation();
              toggleResolve();
            }}
            size="tiny"
            loading={isSubmitting}
            disabled={issue.status === 'dismissed'}
          >
            <Check />
          </IconButton>
        </Box>
      </Tooltip>
      <Tooltip
        title={
          issue.status === 'resolved'
            ? ''
            : issue.status === 'dismissed'
              ? 'Undo dismiss'
              : 'Dismiss'
        }
      >
        <Box sx={issue.status === 'dismissed' ? activeSx : {}}>
          <IconButton
            variant="system"
            onClick={(e) => {
              e.stopPropagation();
              toggleDismiss();
            }}
            size="tiny"
            loading={isSubmitting}
            disabled={issue.status === 'resolved'}
          >
            <Delete />
          </IconButton>
        </Box>
      </Tooltip>
    </Stack>
  );
};
export default IssueActions;
